export default {
  styleOverrides: {
    fontSizeSmall: {
      fontSize: '0.9rem',
    },
  },
};
